/*
*
* File JS per il template Archive Places
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroBig from 'components/hero-big/hero-big';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import archiveFilters from 'components/archive-filters/archive-filters';
import cardPlace from 'components/card-place/card-place';

import pagination from 'components/pagination/pagination';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-place.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();

//--------------------------------------------------------------------//